import { Add, Info, KeyboardArrowDown } from '@mui/icons-material';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  ListSubheader,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import TextField from '@mui/material/TextField';
import { LightTooltip } from 'lib/designSystem/WhiteTooltip';
import {
  formatDate,
  formatMoney,
  validatePermissions,
} from 'lib/functions/utils';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showBusinessNetwork } from 'services/redux/businessNetworkSlice';

import { AuthState } from '../../../../../../../../services/redux/authSlice';
import DocumentsSuggestedContainer from '../../../documentSugestion';
import RequestExpenses from '../../../requestExpenses';
import ArrearPopper from './components/arrearPopper';
import GuaranteeObservationPopper from './components/guaranteeObservationPopper';
import GuaranteeObservationWithHover from './components/guaranteeObservationPopup';

const CustomTooltip = (text: Array<Array<string>>) => (
  <div style={{ padding: 10 }}>
    <div style={{ display: 'flex', alignItems: 'center', paddingBottom: 10 }}>
      <Typography variant="body1">Descripción</Typography>
    </div>
    <Table size="small">
      <TableBody>
        {text.map((row) => (
          <TableRow key={row[0]}>
            <TableCell key={row[0]}>{row[0]}</TableCell>
            <TableCell key={row[1]}>{row[1]}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>
);

const FinanceHubForm = (props: any) => {
  const {
    operationDetails,
    setFormData,
    formData,
    selectedRequest,
    setDocumentsToApply,
    subProduct,
    handleChange,
    documents,
    selected,
    setSelected,
    setDocuments,
    onEditing,
    documentsToApply,
    operationDate,
    formErrors,
    setFormErrors,
    availableArrearTables,
    executivesPortfolio,
    executivesAll,
    requestConfiguration,
    requestExpensesCategories,
    isException,
    setIsException,
  } = props;
  const dispatch = useDispatch();
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);
  const [openGuaranteePopper, setOpenGuaranteePopper] = useState(false);
  const [openArrearPopper, setOpenArrearPopper] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null,
  );
  const gridStyle = {
    alignContent: 'center',
    alignItems: 'center',
    padding: '4px',
    paddingRight: 23,
  };

  const handleAmountToApply = (value: string) => {
    const newValue = Number(value.replace('$', '').replaceAll('.', ''));

    setFormData({
      ...formData,
      amountToApply: newValue,
    });
  };

  const maxAmount =
    operationDetails.operationAdvanced -
    operationDetails.operationCostComissionVariable -
    operationDetails.operationCostComissionFixed -
    operationDetails.expensesCost -
    operationDetails.operationCostRate -
    operationDetails.operationIva -
    operationDetails.expensesIva;

  useEffect(() => {
    if (
      (formErrors.guaranteeObservation &&
        formData.guaranteeAmount > 0 &&
        formData.guaranteeObservation) ||
      formData.guaranteeAmount <= 0
    ) {
      setFormErrors({ ...formErrors, guaranteeObservation: false });
    }
  }, [formData.guaranteeAmount, formData.guaranteeObservation]);

  const handleShowBusinessDetails = () => {
    dispatch(
      showBusinessNetwork({
        id: selectedRequest.businessIdentifier,
        name: selectedRequest.businessName,
      }),
    );
  };

  const handleSetExpenses = (
    expenses: { name: string; amount: number; hasIva: boolean }[],
  ) => {
    setFormData({
      ...formData,
      expenses,
    });
  };

  const arrearRateFixed = requestConfiguration.fixedArrearRate;

  const canEditExchangeDays = validatePermissions(
    user,
    'financing_factoring_edit_exchange_days',
  );

  return (
    <div
      style={{
        padding: '0px 0px',
        borderRight: '1px solid rgba(0, 0, 0, 0.12)',
      }}
    >
      <Grid container style={gridStyle} columnSpacing={3} rowSpacing={1}>
        <Grid item xs={4}>
          <LightTooltip
            title={
              <Typography variant="body1" style={{ padding: 10 }}>
                {selectedRequest.businessName}
              </Typography>
            }
          >
            <div>
              <div>
                <Typography>
                  <b>Cliente: </b>
                </Typography>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <IconButton onClick={handleShowBusinessDetails}>
                  <Info fontSize="small" />
                </IconButton>
                <Typography>
                  {selectedRequest.businessName.length > 18
                    ? `${selectedRequest.businessName.substring(0, 18)}...`
                    : selectedRequest.businessName}
                </Typography>
              </div>
            </div>
          </LightTooltip>
        </Grid>
        <Grid item xs={1.8}>
          <div>
            <div>
              <Typography>
                <b>Rut: </b>
              </Typography>
            </div>
            <Typography>{selectedRequest.businessIdentifier}</Typography>
          </div>
        </Grid>
        <Grid item xs={3.1}>
          <Typography>
            <b>Producto:</b>{' '}
          </Typography>
          <Typography>
            {subProduct ? subProduct.name : selectedRequest.subProductName}
          </Typography>
        </Grid>
        <Grid item xs={3.1}>
          <Typography fontWeight={600}>Fecha operación:</Typography>
          <Typography>{formatDate(selectedRequest.requestDate)}</Typography>
        </Grid>
        <Grid item xs={2.9}>
          <Typography fontWeight={600}>Ejecutivo</Typography>
        </Grid>
        <Grid item xs={2.9}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Typography fontWeight={600}>Montos</Typography>
            <LightTooltip
              title={CustomTooltip([
                [
                  'Anticipo',
                  'Porcentaje a financiar respecto al total del valor de la operación.',
                ],
              ])}
            >
              <Info
                style={{
                  marginLeft: 6,
                  fontSize: 14,
                }}
              />
            </LightTooltip>
          </div>
        </Grid>
        <Grid item xs={6.2}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Typography fontWeight={600}>Tasas</Typography>
            <LightTooltip
              title={CustomTooltip([
                [
                  'Interés',
                  'Interés aplicado a la operación. Se descuenta del monto a financiar como diferencia de precio.',
                ],
                [
                  'Fondo',
                  'Costo de venta a fondo. Utilizado para cálculo de spread. No afecta a la solicitud.',
                ],
                [
                  'Interés mora',
                  'Interés aplicado por cada día de mora en incrementos diarios.',
                ],
              ])}
            >
              <Info style={{ marginLeft: 6, fontSize: 14 }} />
            </LightTooltip>
          </div>
        </Grid>
      </Grid>
      <Grid container style={gridStyle} columnSpacing={3} rowSpacing={1}>
        <Grid item xs={2.9}>
          <Typography variant="body1">Seleccionar ejecutivo</Typography>
          <FormControl fullWidth>
            <Select
              value={formData.executive}
              disabled={!onEditing}
              onChange={(e) => handleChange('executive', e.target.value)}
            >
              <ListSubheader sx={{ fontWeight: 'bold' }}>
                Cliente en cartera
              </ListSubheader>
              {executivesPortfolio.map(
                (executive: { id: string; name: string }) => (
                  <MenuItem key={executive.id} value={executive.id}>
                    {executive.name}
                  </MenuItem>
                ),
              )}
              <ListSubheader sx={{ fontWeight: 'bold' }}>Todos</ListSubheader>
              {executivesAll.map((executive: { id: string; name: string }) => (
                <MenuItem key={executive.id} value={executive.id}>
                  {executive.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={2.9}>
          <Typography variant="body1">Anticipo (%) </Typography>

          <TextField
            value={formData.advance}
            placeholder="100"
            type="number"
            disabled={!onEditing}
            fullWidth
            style={{ padding: '0px !important' }}
            onChange={(e) => handleChange('advance', e.target.value)}
          />
        </Grid>
        <Grid item xs={1.7}>
          <Typography variant="body1">Interés (%)</Typography>
          <TextField
            value={formData.rate}
            type="number"
            fullWidth
            disabled={!onEditing}
            placeholder="2.2"
            onChange={(e) => handleChange('rate', e.target.value)}
          />
        </Grid>
        <Grid item xs={2.1}>
          <Typography variant="body1">Fondo (%)</Typography>
          <TextField
            value={formData.fundRate}
            type="number"
            fullWidth
            disabled={!onEditing}
            placeholder="1"
            onChange={(e) => handleChange('fundRate', e.target.value)}
          />
        </Grid>
        <Grid item xs={2.4}>
          <Typography variant="body1">Interés mora (%)</Typography>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <TextField
              value={
                formData.arrearType === 'table' ? 'Tabla' : formData.arrearRate
              }
              type={formData.arrearType === 'table' ? 'text' : 'number'}
              fullWidth
              disabled={
                !onEditing || formData.arrearType === 'table' || arrearRateFixed
              }
              placeholder="2.2"
              onChange={(e) => handleChange('arrearRate', e.target.value)}
              error={formErrors?.arrearTableId}
            />
            {availableArrearTables.length > 0 && (
              <>
                <IconButton
                  onClick={(e) => {
                    setAnchorEl(e.currentTarget);
                    setOpenArrearPopper(true);
                  }}
                  disabled={!onEditing || arrearRateFixed}
                  color={formErrors?.arrearTableId ? 'error' : undefined}
                >
                  <KeyboardArrowDown />
                </IconButton>
                <ArrearPopper
                  openArrearPopper={openArrearPopper}
                  setOpenArrearPopper={setOpenArrearPopper}
                  anchorEl={anchorEl}
                  formData={formData}
                  handleChange={handleChange}
                  onEditing={onEditing}
                  formErrors={formErrors}
                  setFormErrors={setFormErrors}
                  availableArrearTables={availableArrearTables}
                />
              </>
            )}
          </div>
        </Grid>
        <Grid item xs={12}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Typography fontWeight={600}>Descuentos</Typography>
            <LightTooltip
              title={CustomTooltip([
                [
                  'Monto en garantía',
                  'Monto reservado o en garantía que será liberado cuando el cliente cumpla con los requisitos de la operación.',
                ],
                [
                  'Documentos a aplicar',
                  'Documentos aplicados a la operación abonar al pago de otras facturas.',
                ],
              ])}
            >
              <Info style={{ marginLeft: 6, fontSize: 14 }} />
            </LightTooltip>
          </div>
        </Grid>
      </Grid>
      <Grid container style={gridStyle} columnSpacing={3} rowSpacing={1}>
        <Grid item xs={5.8}>
          <Typography variant="body1">Monto en garantía</Typography>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <TextField
              value={formatMoney(formData.guaranteeAmount)}
              type="text"
              disabled={!onEditing}
              fullWidth
              onChange={(e) => handleChange('guaranteeAmount', e.target.value)}
              error={formErrors?.guaranteeObservation}
            />
            {onEditing ? (
              <IconButton
                onClick={(e) => {
                  setAnchorEl(e.currentTarget);
                  setOpenGuaranteePopper(true);
                }}
                disabled={!onEditing || formData.guaranteeAmount <= 0}
                color={formErrors?.guaranteeObservation ? 'error' : undefined}
              >
                <Add />
              </IconButton>
            ) : (
              <GuaranteeObservationWithHover
                guaranteeObservation={formData?.guaranteeObservation}
                guaranteeAmount={formData?.guaranteeAmount || 0}
                hasError={formErrors?.guaranteeObservation}
              />
            )}
            <GuaranteeObservationPopper
              openGuaranteePopper={openGuaranteePopper}
              setOpenGuaranteePopper={setOpenGuaranteePopper}
              anchorEl={anchorEl}
              formData={formData}
              handleChange={handleChange}
              onEditing={onEditing}
            />
          </div>
        </Grid>
        <Grid item xs={6.2}>
          <Typography variant="body1">Documentos a aplicar ($)</Typography>
          <DocumentsSuggestedContainer
            businessIdentifier={selectedRequest.businessIdentifier}
            setAmountToApply={handleAmountToApply}
            amountToApply={formData.amountToApply}
            maxAmount={maxAmount}
            selected={selected}
            setSelected={setSelected}
            documents={documents}
            setDocuments={setDocuments}
            setDocumentsToApply={setDocumentsToApply}
            addIconPlacement="end"
            disabled={!onEditing}
            documentsToApply={documentsToApply}
            operationDate={operationDate}
          />
        </Grid>
      </Grid>
      <Grid container style={gridStyle} columnSpacing={3} rowSpacing={1}>
        <Grid item xs={5.8}>
          <div style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
            <Typography variant="body1" fontWeight={600}>
              Comisión operación
            </Typography>
            <LightTooltip
              title={CustomTooltip([
                [
                  'Fijo',
                  'Monto fijo a cobrar por la operación. Reducirá el monto a financiar',
                ],
                [
                  'Variable',
                  'Porcentaje a cobrar por la operación. Reducirá el monto a financiar',
                ],
              ])}
            >
              <Info style={{ marginLeft: 6, fontSize: 14 }} />
            </LightTooltip>
          </div>
          <Grid container columnSpacing={3}>
            <Grid item xs={6}>
              <Typography variant="body1">Fijo ($)</Typography>
              <TextField
                value={formatMoney(formData.operationCostComissionFixed)}
                type="text"
                disabled={!onEditing}
                fullWidth
                onChange={(e) =>
                  handleChange('operationCostComissionFixed', e.target.value)
                }
              />
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1">Variable (%)</Typography>
              <TextField
                value={formData.operationCostComissionVariablePercentage}
                type="number"
                fullWidth
                disabled={!onEditing}
                onChange={(e) =>
                  handleChange('operationCostComissionVariable', e.target.value)
                }
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={3.8}>
          <div style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
            <Typography fontWeight={600}>Otros gastos</Typography>
            <LightTooltip
              title={CustomTooltip([
                [
                  'Fijo',
                  'Valor de cualquier otro gasto en el que se incurra en la operación',
                ],
              ])}
            >
              <Info style={{ marginLeft: 6, fontSize: 14 }} />
            </LightTooltip>
          </div>
          <Typography variant="body1">Fijo ($)</Typography>
          <RequestExpenses
            requestExpensesCategories={requestExpensesCategories}
            expenses={formData.expenses}
            setExpenses={handleSetExpenses}
            requestConfiguration={requestConfiguration}
            onEditing={onEditing}
          />
        </Grid>
        <Grid item xs={2.4}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginTop: 10,
            }}
          >
            <Typography fontWeight={600}>Canje</Typography>
            <LightTooltip
              title={CustomTooltip([
                [
                  'Dás de canje',
                  'Días a sumar para el cálculo de la diferencia de precio',
                ],
              ])}
            >
              <Info style={{ marginLeft: 6, fontSize: 14 }} />
            </LightTooltip>
          </div>
          <Typography variant="body1">Días de canje</Typography>
          <TextField
            value={formData.exchangeDays}
            type="number"
            disabled={!onEditing || !canEditExchangeDays}
            fullWidth
            placeholder="0"
            onChange={(e) => handleChange('exchangeDays', e.target.value)}
          />
        </Grid>
        {selectedRequest.status === 'Creando' && (
          <Grid item xs={12}>
            <FormControl>
              <FormControlLabel
                control={<Checkbox size="small" checked={isException} />}
                label="Excepción"
                onChange={(e: any) => setIsException(e.target.checked)}
              />
            </FormControl>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default FinanceHubForm;
